import React from 'react'

class StyleProps {
  static create<T extends { [key: string]: React.CSSProperties }>(arg: T): T {
    return arg
  }
}
export { StyleProps }
